module.exports = __webpack_public_path__ + "static/img/gaishu-jieshao.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gaishu-jieshao.png
// module id = nH3A
// module chunks = 1